export default __webpack_public_path__ + "static/media/bitcoin.0d62c38a.svg";